require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 3633
// module chunks = 0